/**
 * @fileoverview Functions related to fetching posts
 */
var ads = require('./ads');
var analytics = require('./analytics');
var comments = require('./comments');
var $ = require('jquery');
var util = require('./util')

var URL_POSTFIX = '/wp-content/themes/theinertia-2018/quick-ajax.php';

function setupVideoEmbed($html) {
  var jws = $html.find('script[src^="https://content.jwplatform"]');
  if (!jws.length) {
    return;
  }
  var s = document.createElement('script');
  s.src = jws[0].src;
  s.async = 1;
  s.type = 'text/javascript';
  $html.prepend(s);
}

function getReq(action) {
  return function (baseUrl, data, callback) {
    var getData = {'action': action};
    if (/2018=1/.test(window.location.href)) {
      getData['2018'] = 1;
    }
    // Pass mobile detection flag for AJAX requests
    getData['is_mobile_js'] = window.matchMedia('(max-width: 768px)').matches ? '1' : '0';
    $.extend(getData, data);
    // Default to HTML for most requests (recent_posts, etc.)
    $.get(baseUrl + URL_POSTFIX, getData, callback);
  };
}

function getReqJson(action) {
  return function (baseUrl, data, callback) {
    var getData = {'action': action};
    if (/2018=1/.test(window.location.href)) {
      getData['2018'] = 1;
    }
    // Pass mobile detection flag for AJAX requests
    getData['is_mobile_js'] = window.matchMedia('(max-width: 768px)').matches ? '1' : '0';
    $.extend(getData, data);
    // Specify 'json' dataType for JSON responses (render_single_post)
    $.get(baseUrl + URL_POSTFIX, getData, callback, 'json');
  };
}

var maxArticles = 3;
var loadedArticles = {};
function articleLoader(triggerElement, insertElement, id, baseUrl, isMobile, done) {
  if (!triggerElement.length) {
    return;
  }
  
  triggerElement.data('title', document.title);
  triggerElement.data('permalink', window.location.href);

  var titleEl = $('.inertia-nav-text');

  util.scrollWatcher(triggerElement, 400, function(eventType, watcher) {
    if (eventType === 'enter') {
      var excludeIds = Object.keys(loadedArticles);

      var shouldLoadMore = excludeIds.length < maxArticles;

      if (!(id in loadedArticles) && shouldLoadMore) {
        excludeIds.push(id);

        var queryParams = {
          post_id: id,
          first: true,
          exclude_ids: excludeIds.length ? excludeIds.join(',') : ''
        };

        if (/2018=1/.test(window.location.href)) {
          queryParams['2018'] = 1;
        }

        getReqJson('render_single_post')(baseUrl, queryParams, function (data) {
          var html = $(data.html);
          setupVideoEmbed(html);
          html.insertAfter(insertElement);
          titleEl && titleEl.text(data.title);
          analytics.pageView();
          loadedArticles[id] = {title: data.title, permalink: data.permalink};
          history.replaceState({}, data.title, data.permalink);
          ads.init(data.id, true);
          done(baseUrl, isMobile, {post_id: data.id});
        });
      } else {
        if (id in loadedArticles) {
          history.replaceState({}, loadedArticles[id].title, loadedArticles[id].permalink);
          titleEl && titleEl.text(loadedArticles[id].title);
          document.title = loadedArticles[id].title;
        }
      }
    }

    if (eventType === 'exit') {
      if (watcher.isBelowViewport) {
        history.replaceState({}, triggerElement.data('title'), triggerElement.data('permalink'));
        titleEl && titleEl.text(triggerElement.data('title'));
        document.title = triggerElement.data('title');
      }
    }
  });
}

module.exports = {
  getRecent: getReq('recent_posts'),           // Returns HTML
  getNext: getReqJson('render_single_post'),   // Returns JSON
  articleLoader: articleLoader
}
